import { getInstance } from '@ctct/distui-helpers';

export const getCustomerCurrency = async () => {
  const DistUI = await getInstance();

  return DistUI?.getAccountData?.().billingCustomer?.currencyCd ?? null;
};

export const getDisabledActivities = async () => {
  const DistUI = await getInstance();

  return DistUI?.getAccountData?.().planGroup?.disabledActivities ?? null;
};

export const getBillingCustomerCurrency = async (defaultCurrencyCode = 'USD') => {
  const customerCurrency = await getCustomerCurrency();

  return customerCurrency ?? defaultCurrencyCode;
};

export const getAccountId = async () => {
  const DistUI = await getInstance();

  return DistUI.getAccountId();
};
